import { IQService } from 'angular'

//#region Util Imports

import * as _ from 'underscore'
import * as moment from 'moment'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import { locale as globalizeLocale } from 'globalize'

//#endregion

import { Api, LocalDictionaryFactory } from './../../api/api.module'
import { CorrespondingActionTypeModel, ColumnModel, FieldModel } from '../../api/api.models'

import { ActionStatusOptions } from '../action-status/action-status.controller'

import { LoggerService } from '../../common/common.module'
import { CommonHelper, DataType } from '../../../helpers/common-helper'
import { i18n } from '../../common/i18n/common.i18n'

import { DataProvider } from '../../../helpers/data-provider'
import { Md5 } from '../../../helpers/md5-helper'
import { EventsNames } from '../../../helpers/events-names'
import { ToastHelper } from '../../../helpers/toast-helper'
import { ConvertHelper } from '../../../helpers/convert-helper'
import { ReferenceTypeComponent, ConfigHelper, TypeHelper } from '../../../helpers'
import { LocalizationHelper } from '../../../helpers/localization-helper'

import { ColumnInfo, OpActionResult } from '../../../models/custom'
import { OpCoord } from '../../../models/custom/op-map-area'
import { Enums } from '../../../models/common/enums'
import { OpDataTypeFormat } from '../../../models/core/op-data-type-format'
import { OpActionData } from '../../../models/core/op-action-data'
import { OpActionType } from '../../../models/core/op-action-type'
import { IOpObject } from '../../../models/util/interfaces'
import { OpViewColumn, OpView } from '../../../models/core'
import { SESSION } from '../../../models/custom/session'
import { Activity } from '../../../models/common/activity'
import { DataValue } from '../../../models/local'
import { IMRBaseControlDirectiveController } from '../base'

import { DateBoxControlsService } from '../../../services/controls'
import { UserSessionService } from '../../../services/user-session'
import { ActionService } from '../../../services/action'
import {
	ValveManageInitializedArgs,
	IValveManage,
	ValveManageOptions,
	AlzActionInitializedArgs,
	IAlzAction,
	AlzActionOptions,
	AstGsmActionInitializedArgs,
	AstGsmActionOptions,
	IAstGsmAction,
	IImmediatelyArchDateAction,
	ImmediatelyArchDateActionInitializedArgs,
	ImmediatelyArchDateActionOptions,
} from './action-run-dedicated'
import { CreateEditSection, ExtendedFormItem } from '../common.create-edit'

interface ActionRunScope extends ng.IScope {
	popupId: number

	popupOptions: DevExpress.ui.dxPopupOptions

	popupTitle: string
	popupVisible: boolean

	popupHeight: number
	popup: DevExpress.ui.dxPopup
	toolbarOptions: DevExpress.ui.dxToolbarOptions
	selectBoxOptions: DevExpress.ui.dxSelectBoxOptions
	correspondingActionTypes: CorrespondingActionTypeModel[]
	selected: any
	source: Source
	succededActions: any[]
	failedActions: any[]
	inProgressActions: any[]

	//Form props
	isFormVisible: boolean
	dictionary: any
	data: FieldModel[]
	panels: any
	tabItems: any[]
	getCoords(): any
	onLocationSelected(lat: number, lng: number): void
	onPopoverValueIdSelected(valueId: number, datatypeId: number): void
	isPlanActionVisible(): boolean
	isEditMode: boolean

	dateFormat: string

	showLoader: boolean

	actionRunPlanCheckBoxOptions: DevExpress.ui.dxCheckBoxOptions
	actionRunPlanRadioGroupOptions: DevExpress.ui.dxRadioGroupOptions
	actionRunPlanDateBoxOptions: DevExpress.ui.dxDateBoxOptions[]
	showActionRunPlanRadioGroup: boolean
	valveManagePopupOptions: ValveManageOptions

	alzActionPopupOptions: AlzActionOptions
	astGsmActionPopupOptions: AstGsmActionOptions
	immediatelyArchDateActionPopupOptions: ImmediatelyArchDateActionOptions

	isActionExplanationRequired: () => boolean
	actionExplanationTextAreaBoxOptions: DevExpress.ui.dxTextAreaOptions
	actionExplanationTextAreaValidatorOptions: DevExpress.ui.dxValidatorOptions
	actionExplanationTextAreaLabelText: string
}

export interface Source {
	popupTitle: string
	itemsList: any
	selectedValue: number
	submitButtonText: string
	onSubmit(value: number): void
}

// Temporary interface for action run (field of action run)
// TODO: remove it later and use OpActionData
export interface ActionRunField {
	idActionData: number
	idDataType: number
	index: number
	value: any

	// name and caption? wtf?
	name: string
	caption: string
	// ---

	// TODO: should be only DataType
	type: string
	typeId: number
	referenceTypeId: number
	isEditable: boolean
	format: OpDataTypeFormat
	unitName: string
	// ---
}

// Temporary interface for action run
// TODO: remove it later and use OpActionType
export interface ActionRun {
	id: number
	name: string
	originalName: string
	type: Enums.ReferenceType
	referenceValues: number[]
	isActionDataFixed: boolean
	fields?: ActionRunField[]
}

export interface ActionRunOptions {
	actions: ActionRun[]
	idDataType: number
	selectedRowsNames: string[]
	actionTypes: OpActionType[]
}

export class ActionRunController extends IMRBaseControlDirectiveController {
	private referenceTableCount: number = 0
	private referenceTypeFieldName: string = 'referenceTypeField'
	private normalPopupHeight: number = 195
	private planActionCheckBoxPopupHeight: number = 270
	private planActionPopupHeight: number = 440
	private extendedPopupHeight: number = 500

	private selectedRowsNames: any[]

	private isActionRunPopup: boolean
	private moduleDataType: number

	private prevousSentActionsMd5: string
	private previousSentActionsFail: boolean = false

	private selectedActionType: CorrespondingActionTypeModel
	private planActionCheckBox: DevExpress.ui.dxCheckBox
	private planActionRadioGroup: DevExpress.ui.dxRadioGroup
	private planActionDateBox: DevExpress.ui.dxDateBox[] = []
	private valveManagmentComponent: IValveManage
	private alzActionComponent: IAlzAction
	private astGsmActionComponent: IAstGsmAction
	private immediatelyArchDateActionComponent: IImmediatelyArchDateAction
	private actionTypes: OpActionType[]
	private planActionScheduleModeValue: FieldModel

	private readonly explanationFieldOffcet: number = 36
	private isExplanationOffcetApplied: boolean = false
	private actionExplanationTextAreaValidator: DevExpress.ui.dxValidator
	private actionExplanationTextAreaBox: DevExpress.ui.dxTextArea

	constructor(
		private $scope: ActionRunScope,
		private readonly $q: IQService,
		private $element: JQuery,
		private $timeout: ng.ITimeoutService,
		private api: Api,
		private logger: LoggerService,
		private localDictionary: LocalDictionaryFactory,
		private dateBoxControlsService: DateBoxControlsService,
		private userSession: UserSessionService,
		private actionService: ActionService
	) {
		super()

		$scope.popupVisible = false
		$scope.popupHeight = this.normalPopupHeight
		$scope.isFormVisible = false
		$scope.dateFormat = window['simax'].getDateTimeFormat('DATE_FORMAT_DX')

		$scope.popupOptions = {
			bindingOptions: {
				visible: 'popupVisible',
				title: 'popupTitle',
				maxHeight: 'popupHeight',
			},
			maxWidth: 600,
			showTitle: true,
			closeOnOutsideClick: true,
			onHiding: () => {
				restoreForm()
				$scope.selected = null
			},
			onInitialized: (e) => {
				$scope.popup = e.component
			},
			onShowing: () => {
				this.prevousSentActionsMd5 = ''
			},
		}

		$scope.selectBoxOptions = {
			displayExpr: 'name',
			valueExpr: (e: any) => e, // Moze sie zdazyc tak, ze beda 2 action type o tym samym id wiec niech kluczem bedzie obiekt a nie idActionType
			bindingOptions: {
				dataSource: 'correspondingActionTypes',
				value: 'selected',
			},
			noDataText: i18n('Common', 'NoData'),
			placeholder: i18n('Common', 'Select'),
			onSelectionChanged: (item: any) => {
				if (this.isActionRunPopup) {
					$scope.showLoader = true
					if (this.planActionCheckBox != null) {
						this.planActionCheckBox.option('value', false)
					}

					this.selectedActionType = item.selectedItem

					if ($scope.isActionExplanationRequired() && this.isExplanationOffcetApplied != true) {
						this.extendedPopupHeight += this.explanationFieldOffcet
						this.planActionCheckBoxPopupHeight += this.explanationFieldOffcet
						this.planActionPopupHeight += this.explanationFieldOffcet
						this.isExplanationOffcetApplied = true
					}

					if (
						item.selectedItem != null &&
						!item.selectedItem.isActionDataFixed &&
						item.selectedItem.type != null &&
						item.selectedItem.referenceValues != null &&
						item.selectedItem.referenceValues.length > 0 &&
						item.selectedItem['originalName'] != Enums.ActionType.ALZ_CONFIGURATION &&
						item.selectedItem['originalName'] != Enums.ActionType.IMMEDIATELY_GET_ARCHIVE
					) {
						userSession
							.getDataProvider()
							.Action.getActionParameters(item.selectedItem.id, item.selectedItem.type, item.selectedItem.referenceValues)
							.then((params: OpActionData[]) => {
								if (item.selectedItem != null) {
									setActionRunField(params, item.selectedItem)
								}
							})
							.then(() => {
								prepareForm()
							})
							.fail((error: any) => {
								const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
								ToastHelper.showError(errorMsg)
								console.warn(`Can't download parameters for the action ${item.selectedItem.name} (${item.selectedItem.id})`)
							})
					} else {
						setActionRunField([], item)
						prepareForm()
					}
				}
			},
		}

		$scope.isActionExplanationRequired = (): boolean => {
			return this.selectedActionType != null ? this.userSession.getLoggedOperator().hasPermission(Activity.ACTION_ADD_SENDING_EXPLANATION, this.selectedActionType.id) : false
				&& $scope.selected
				&& $scope.actionExplanationTextAreaBoxOptions != null
				&& $scope.actionExplanationTextAreaValidatorOptions != null
		}

		$scope.toolbarOptions = {
			items: [
				{
					location: 'after',
					widget: 'dxButton',
					options: {
						text: $scope.source ? $scope.source.submitButtonText : i18n('Common', 'Run'),
						onClick: () => {
							submit()
						},
					},
				},
				{
					location: 'after',
					widget: 'dxButton',
					options: {
						text: i18n('Common', 'Cancel'),
						onClick: () => {
							$scope.popupVisible = false
							restoreForm()
						},
					},
				},
			],
		}

		$scope.getCoords = () => {
			return this.getCoords()
		}

		$scope.onLocationSelected = (lat: number, lng: number) => {
			this.onLocationSelected(lat, lng)
		}

		$scope.onPopoverValueIdSelected = (valueId: number, datatypeId: number = null) => {
			this.onPopoverValueIdSelected(valueId, datatypeId)
		}

		$scope.$on(EventsNames.OPEN_RUN_ACTION_POPUP + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
			let settings: ActionRunOptions = args[0]
			this.actionTypes = settings.actionTypes != null ? settings.actionTypes : []
			$scope.popupTitle = $scope.source ? $scope.source.popupTitle : i18n('Popup', 'SelectActionRun') + ' (' + settings.selectedRowsNames.length + ')'
			$scope.correspondingActionTypes = $scope.source ? $scope.source.itemsList : settings.actions
			this.selectedRowsNames = settings.selectedRowsNames
			$scope.popupVisible = true
			$scope.selected = $scope.source ? $scope.source.selectedValue : null

			if ($scope.selected == null && _.size($scope.correspondingActionTypes) == 1) {
				$scope.selected = $scope.correspondingActionTypes[0]

				if (this.actionTypes[0].name == Enums.ActionType.ALZ_CONFIGURATION) {
					this.initializeAlzActionPopup($scope.correspondingActionTypes[0])
				}

				if (this.actionTypes[0].name == Enums.ActionType.AST_GSM) {
					this.initializeAstGsmActionPopup($scope.correspondingActionTypes[0])
				}

				if (this.actionTypes[0].name == Enums.ActionType.IMMEDIATELY_GET_ARCHIVE) {
					this.initializeImmediatelyArchDateActionPopup($scope.correspondingActionTypes[0])
				}
			}

			this.moduleDataType = settings.idDataType
			this.isActionRunPopup = true
		})

		$scope.$on(EventsNames.RUN_ACTION_DIRECTLY + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
			const action: CorrespondingActionTypeModel = args[0]
			if (action != null) {
				this.moduleDataType = action.type
				this.selectedRowsNames = action.referenceValues
				this.runAction(action)
			}
		})

		const setActionRunField = (params: OpActionData[], selectedItem: any) => {
			if (selectedItem != null && params != null && params.length > 0) {
				selectedItem.fields = params.map((param: OpActionData) => {
					if (param != null && (param.dataType == null || param.dataType.idDataType == null)) {
						// TODO Użyć getDataType
						param.dataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(param.idDataType)
					}

					return <ActionRunField>{
						idActionData: param.idActionData,
						idDataType: param.idDataType,
						index: param.indexNbr != null ? param.indexNbr : 0,
						name: param.idDataType.toString(),
						caption: param.dataType != null ? param.dataType.toString() : '',
						type: param.dataType != null && param.dataType.dataTypeClass != null ? param.dataType.dataTypeClass.name : '',
						typeId: param.dataType != null && param.dataType.dataTypeClass != null ? param.dataType.idDataTypeClass : 0,
						format: param.dataType != null ? param.dataType.dataTypeFormat : null,
						isEditable: param.dataType != null ? param.dataType.isEditable : true,
						value: param.value,

						referenceTypeId: param.dataType != null ? param.dataType.idReferenceType : null,
						unitName: param.dataType && param.dataType.unit ? param.dataType.unit.toString() : null,
					}
				})
			}
		}

		const prepareForm = () => {
			//FORM
			const selectedItem: CorrespondingActionTypeModel[] = $scope.correspondingActionTypes.filter((item) => item == $scope.selected)
			if (
				selectedItem != null &&
				selectedItem.length > 0 &&
				selectedItem[0] != null &&
				selectedItem[0].fields != null &&
				selectedItem[0].fields.length > 0 &&
				loadColumns($scope.correspondingActionTypes.filter((item) => item == $scope.selected)[0].fields)
			) {
				$scope.popupHeight = this.extendedPopupHeight

				this.updateTabs($scope, $scope.dictionary)
				$scope.panels = []

				$scope.dictionary.forEach((section) => {
					switch (section.type) {
						default:
						case 'form':
							this.createForm(section, $scope.data)
							break
					}
					$scope.panels.push(section)
				})

				$timeout(() => {
					$scope.isFormVisible = true
					$scope.showLoader = false
				}, 200)
			} else {
				restoreForm()
			}
		}

		const loadColumns = (fields: FieldModel[]) => {
			const columns: ColumnModel[] = []
			const data: any[] = []

			fields.forEach((field: FieldModel) => {
				if (field.idDataType !== Enums.DataType.ACTION_SCHEDULE_MODE) {
					const col: ColumnModel = new ColumnModel()

					const dataTypesCount: number = _.filter(fields, (fieldItem: FieldModel) => fieldItem.idDataType === field.idDataType).length

					col.caption = `${field.caption}${dataTypesCount > 1 ? '[' + field.index + ']' : ''} ${field.unitName ? '[' + field.unitName + ']' : ''}`
					col.format = field.format
					col.isEditable = true
					col.id = field.idDataType
					col.name = field.name
					col.type = field.typeId
					col.unitName = field.unitName
					col.referenceTypeId = field.referenceTypeId
					col.idName = field.index != 0 ? field.idDataType.toString() + '_' + field.index : field.idDataType.toString()

					columns.push(col)

					data[col.idName] = field
				} else {
					if ($scope.isPlanActionVisible()) {
						this.planActionCheckBox.option('value', true)
						this.planActionRadioGroup.option('value', field.value)
					} else {
						const planActionScheduleModeValue: FieldModel = new FieldModel()
						planActionScheduleModeValue.index = 0
						planActionScheduleModeValue.idDataType = Enums.DataType.ACTION_SCHEDULE_MODE
						planActionScheduleModeValue.value = field.value
						planActionScheduleModeValue.typeId = 0
						this.planActionScheduleModeValue = planActionScheduleModeValue
					}
				}
			})

			const dict = {
				name: i18n('Common', 'Basics'),
				type: 'form',
				columns: columns,
			}

			$scope.dictionary = [dict]
			$scope.data = data

			if (columns.length > 0) {
				return true
			} else {
				return false
			}
		}

		const restoreForm = () => {
			$scope.isFormVisible = false
			$scope.panels = []
			$scope.popupHeight = this.planActionCheckBoxPopupHeight

			if (this.isExplanationOffcetApplied == true) {
				this.extendedPopupHeight -= this.explanationFieldOffcet
				this.planActionCheckBoxPopupHeight -= this.explanationFieldOffcet
				this.planActionPopupHeight -= this.explanationFieldOffcet
				this.isExplanationOffcetApplied = false
			}

			$scope.showLoader = false
		}

		const submit = () => {
			if (!$scope.source) {
				if ($scope.selected != null) {
					const actionType: CorrespondingActionTypeModel = this.selectedActionType || _.first($scope.correspondingActionTypes.filter((item) => item == $scope.selected))
					if (actionType) {
						const planActionScheduleFields: FieldModel[] = []

						let isRunActionExplanationValid: boolean = true
						const runActionExplanationFields: FieldModel[] = []

						if ($scope.isActionExplanationRequired() == true) {
							if (this.actionExplanationTextAreaValidator != null) {
								const validateRes: DevExpress.ui.dxValidatorResult = this.actionExplanationTextAreaValidator.validate()

								if (validateRes != null) {
									isRunActionExplanationValid = validateRes.isValid
								}

								if (isRunActionExplanationValid == true) {
									const runActionExplanationValue: FieldModel = new FieldModel()
									runActionExplanationValue.index = 0
									runActionExplanationValue.idDataType = Enums.DataType.ACTION_RUN_EXPLANATION
									runActionExplanationValue.value = this.actionExplanationTextAreaBox.option('value')
									runActionExplanationValue.typeId = 0

									runActionExplanationFields.push(runActionExplanationValue)
								}
							}
						}

						if (this.planActionRadioGroup != null && $scope.isPlanActionVisible()) {
							const actionScheduleMode: number = this.planActionRadioGroup.option('value')

							if (this.planActionCheckBox.option('value') === true) {
								const planActionScheduleModeValue: FieldModel = new FieldModel()
								planActionScheduleModeValue.index = 0
								planActionScheduleModeValue.idDataType = Enums.DataType.ACTION_SCHEDULE_MODE
								planActionScheduleModeValue.value = actionScheduleMode
								planActionScheduleModeValue.typeId = 0

								planActionScheduleFields.push(planActionScheduleModeValue)

								if (actionScheduleMode === Enums.ActionScheduleMode.ExecuteAtTime || actionScheduleMode === Enums.ActionScheduleMode.WaitForPacket) {
									const planActionTimeValue: FieldModel = new FieldModel()
									planActionTimeValue.index = 0
									planActionTimeValue.idDataType = Enums.DataType.ACTION_SCHEDULE_TIME
									planActionTimeValue.value = this.planActionDateBox[actionScheduleMode].option('value')
									planActionTimeValue.typeId = 0

									planActionScheduleFields.push(planActionTimeValue)
								}

								actionType.fields = [...planActionScheduleFields]
							}
						} else {
							if (this.planActionScheduleModeValue != null) {
								planActionScheduleFields.push(this.planActionScheduleModeValue)
								actionType.fields = [...planActionScheduleFields]
							}
						}

						let currentMd5: string
						if (actionType.isActionDataFixed) {
							currentMd5 = Md5.init(actionType)

							if (this.prevousSentActionsMd5 !== currentMd5 || this.previousSentActionsFail) {
								this.prevousSentActionsMd5 = currentMd5

								if (actionType != null && actionType['originalName'] == Enums.ActionType.ALZ_CONFIGURATION) {
									this.initializeAlzActionPopup(actionType)
									this.prevousSentActionsMd5 = new Date().getTime().toString()
								} else {
									this.runAction(actionType)
								}

								return
							}
						} else {
							const sections: any[] = this.$scope.panels

							let isValid: boolean = true
							sections.forEach((section, index) => {
								this.$scope['showSectionError' + index] = false
								if (section.form && !section.form.validate().isValid) {
									section.showRequiredError = true
									this.$scope['showSectionError' + index] = true
									isValid = false
								}

								return true
							})

							if (isValid && isRunActionExplanationValid) {
								const unique: any = {}
								const fields: FieldModel[] = []
								fields.push(...planActionScheduleFields)
								fields.push(...runActionExplanationFields)

								sections.forEach((section) => {
									if (section.form) {
										Object.keys(section.formData).forEach((property) => {
											let date: Date
											let typeId: number

											if (Object.prototype.toString.call(section.formData[property]) === '[object Date]') {
												const momentDate: any = moment(section.formData[property], window['simax'].getDateTimeFormat('DATE_TIME_FORMAT_MOMENTJS'))
												date = momentDate.add(momentDate.utcOffset(), 'minutes').toDate()
												const col: ColumnModel = section.columns.filter((column: ColumnModel) => column.idName == property)[0]
												if (col.type == CommonHelper.time) {
													typeId = CommonHelper.time
												}
											}
											let id: number = parseInt(property)
											let index: number = 0

											if (property.indexOf('_') > 0) {
												id = parseInt(property.split('_')[0])
												index = parseInt(property.split('_')[1])
											}

											if (!unique[property]) {
												const nameValue: FieldModel = new FieldModel()
												nameValue.index = index
												nameValue.idDataType = id
												nameValue.value = date ? date : section.formData[property]
												nameValue.typeId = typeId ? typeId : 0
												fields.push(nameValue)
												unique[property] = true
											}
										})
									}

									if (section.grid) {
										section.grid
											.option('dataSource')
											.items()
											.forEach((item) => {
												const id: number = parseInt(item.index)

												if (!unique[id]) {
													const nameValue: FieldModel = new FieldModel()
													nameValue.idDataType = id
													nameValue.value = item.value
													fields.push(nameValue)
													unique[id] = true
												}
											})
									}
								})

								actionType.fields = fields

								if (this.prevousSentActionsMd5 !== currentMd5 || this.previousSentActionsFail) {
									this.prevousSentActionsMd5 = currentMd5

									const foundActionType: OpActionType = _.find(this.actionTypes, (action: OpActionType) => action.idActionType == actionType.id && action.toString() == actionType.name)

									if ((foundActionType != null && Enums.ActionType.CLOSE_VALVE === foundActionType.name) || Enums.ActionType.OPEN_VALVE_SAFE === foundActionType.name) {
										this.initializeValveManagmentPopup(actionType)
										this.prevousSentActionsMd5 = new Date().getTime().toString()
									} else if (foundActionType != null && Enums.ActionType.ALZ_CONFIGURATION === foundActionType.name) {
										this.initializeAlzActionPopup(actionType)
										this.prevousSentActionsMd5 = new Date().getTime().toString()
									} else if (foundActionType != null && Enums.ActionType.AST_GSM === foundActionType.name) {
										this.initializeAstGsmActionPopup(actionType)
										this.prevousSentActionsMd5 = new Date().getTime().toString()
									} else if (foundActionType != null && Enums.ActionType.IMMEDIATELY_GET_ARCHIVE === foundActionType.name) {
										this.initializeImmediatelyArchDateActionPopup(actionType)
										this.prevousSentActionsMd5 = new Date().getTime().toString()
									} else {
										this.runAction(actionType)
									}

									return
								}
							} else {
								CommonHelper.openInfoPopup(i18n('Common', 'IncorrectData'), 'error', 5000)
								angular.element('.dx-invalid').css('height', '36px')

								return
							}
						}
					}
				} else {
					CommonHelper.openInfoPopup(i18n('Common', 'NothingSelected'), 'warning', 2000)
				}
			} else {
				$scope.popupVisible = false
				$scope.source.onSubmit($scope.selected)
			}
		}

		$scope.actionRunPlanRadioGroupOptions = {
			onInitialized: (e: any) => {
				this.planActionRadioGroup = e.component
			},
			dataSource: [
				{
					text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExecuteActionAt),
					value: Enums.ActionScheduleMode.ExecuteAtTime,
				},
				{
					text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExecuteActionAfterReceivingPacket),
					value: Enums.ActionScheduleMode.WaitForPacket,
				},
				{
					text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExecuteActionAfterProcessingPacket),
					value: Enums.ActionScheduleMode.WaitForData,
				},
			],
			valueExpr: 'value',
			value: Enums.ActionScheduleMode.ExecuteAtTime,
			onValueChanged: (e: any) => {
				if (e.value === Enums.ActionScheduleMode.ExecuteAtTime || e.value === Enums.ActionScheduleMode.WaitForPacket) {
					this.planActionDateBox[e.value].option('disabled', false)
					this.planActionDateBox.forEach((dateBox: DevExpress.ui.dxDateBox, index: number) => {
						if (index !== e.value) {
							dateBox.option('disabled', true)
						}
					})
				} else {
					this.planActionDateBox.forEach((dateBox: DevExpress.ui.dxDateBox) => {
						dateBox.option('disabled', true)
					})
				}
			},
			itemTemplate: (itemData: any, itemIndex: number, $itemElement: JQuery) => {
				$itemElement.parent().css('display', 'flex')
				const name: JQuery = $('<span></span>')
				name.append(itemData.text)
				$itemElement.append(name)
				if (itemData.value === Enums.ActionScheduleMode.ExecuteAtTime || itemData.value === Enums.ActionScheduleMode.WaitForPacket) {
					const dateBox: JQuery = $('<div></div>')
					dateBox.dxDateBox($scope.actionRunPlanDateBoxOptions[itemData.value])
					$itemElement.append(dateBox)
				}
			},
		}

		$scope.actionRunPlanCheckBoxOptions = {
			onInitialized: (e: any) => {
				this.planActionCheckBox = e.component
			},
			onValueChanged: (e: any) => {
				if (e.value === true) {
					$scope.showActionRunPlanRadioGroup = true

					if (_.size($scope.panels) === 0) {
						$scope.popupHeight = this.planActionPopupHeight
					}
				} else {
					$scope.showActionRunPlanRadioGroup = false

					if (_.size($scope.panels) === 0) {
						$scope.popupHeight = this.planActionCheckBoxPopupHeight
					}
				}
			},
			text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScheduleActionExecution),
			value: false,
		}

		$scope.actionRunPlanDateBoxOptions = []

		$scope.actionRunPlanDateBoxOptions[Enums.ActionScheduleMode.ExecuteAtTime] = {
			type: 'datetime',
			max: null,
			displayFormat: ConfigHelper.getDateTimeFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_DX),
			onInitialized: (e: any) => {
				this.planActionDateBox[Enums.ActionScheduleMode.ExecuteAtTime] = e.component
			},
			disabled: false,
			min: moment().toDate(),
			value: moment().toDate(),
		}

		$scope.actionRunPlanDateBoxOptions[Enums.ActionScheduleMode.WaitForPacket] = {
			type: 'datetime',
			max: null,
			displayFormat: ConfigHelper.getDateTimeFormat(ConfigHelper.DateFormat.DATE_TIME_FORMAT_DX),
			onInitialized: (e: any) => {
				this.planActionDateBox[Enums.ActionScheduleMode.WaitForPacket] = e.component
			},
			disabled: true,
			min: moment().toDate(),
			value: moment().add(1, 'days').toDate(),
		}

		/* 
		If actionType.name == Enum.ActionType we dont want to show it in action run popup
		*/
		$scope.isPlanActionVisible = () => {
			const actionType: OpActionType = _.find(this.actionTypes, (actionType: OpActionType) => actionType.idActionType == $scope.selected.id)
			return (
				actionType != null &&
				actionType.name != Enums.ActionType.OPEN_VALVE_SAFE &&
				actionType.name != Enums.ActionType.CLOSE_VALVE &&
				actionType.name != Enums.ActionType.ALZ_CONFIGURATION &&
				actionType.name != Enums.ActionType.AST_GSM &&
				actionType.name != Enums.ActionType.IMMEDIATELY_GET_ARCHIVE &&
				this.userSession.getLoggedOperator().hasPermission(Activity.ACTION_RUN_PLAN_OP)
			)
		}

		$scope.actionExplanationTextAreaBoxOptions = {
			minHeight: 72,
			onInitialized: (e: any) => {
				this.actionExplanationTextAreaBox = e.component
			},
		}

		$scope.actionExplanationTextAreaLabelText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ReasonForChange)
		$scope.actionExplanationTextAreaValidatorOptions = {
			validationRules: [{
				type: 'required',
				message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
			},{
				type: 'stringLength',
				max: 500,
				message: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MaxNumberOfCharacters)} 500`
			}],
			onInitialized: (e: any) => {
				this.actionExplanationTextAreaValidator = e.component
			}
		}

	}

	private updateTabs($scope: ActionRunScope, sections: any[]) {
		$scope.tabItems = sections.map((section) => {
			return {
				template: (itemData, itemIndex, itemElement) => {
					$scope['showSectionError' + itemIndex] = false
					return (
						section.name +
						'<ng-md-icon ng-show="showSectionError' +
						itemIndex +
						'" icon="' +
						window['config']['ICONS']['REQUIRED_TAB'] +
						'" style="fill: #ea4444; vertical-align: middle;" size="20"></ng-md-icon>'
					)
				},
			}
		})
	}

	private createForm(section, data): void {
		section.formData = {}
		section.items = []
		section.onFieldChanged = (e) => {
			if (e.dataField) {
				if (!isNaN(parseFloat(e.value))) {
					section.formData[e.dataField] = parseFloat(e.value)
				} else {
					section.formData[e.dataField] = e.value
				}

				this.trackChanges(section, e.dataField, e.value)
			} else {
				var value = e.selectedItem ? e.selectedItem.id : ''
				var index = e.element.get(0).attributes['field-id'].nodeValue
				section.formData[index] = value
				this.trackChanges(section, index, value)
			}
		}

		section.onDateFieldChanged = (e) => {
			const index = e.element.get(0).attributes['field-id'].nodeValue
			this.trackChanges(section, index, e.value)
		}

		section.options = <DevExpress.ui.dxFormOptions>{
			onFieldDataChanged: (e: any) => {
				this.trackChanges(section, e.dataField, e.value)
			},
			requiredMark: '*',
			showRequiredMark: true,
			labelLocation: 'top',
			colCount: 2,
			width: '100%',
			height: '100%',
			scrollingEnabled: false,
			bindingOptions: {
				formData: 'panel.formData',
				items: 'panel.items',
			},
			onInitialized: (e) => {
				section.form = e.component
				this.$scope.showLoader = true

				this.loadForm(section, data)
					.then(() => {
						section.form.option({ items: section.items })
						this.$scope.showLoader = false
					})
			},
		}

		if (section.form) {
			this.$scope.showLoader = true
			this.loadForm(section, data)
				.then(() => {
					section.form.option({ items: section.items })
					this.$scope.showLoader = false
				})
		}
	}

	private trackChanges(section, index, value): void {
		this.$scope.panels.forEach((panel) => {
			if (panel != section) {
				if (panel.form) {
					panel.formData[index] = value
				}

				if (panel.grid) {
					panel.grid
						.option('dataSource')
						.items()
						.every((item) => {
							if (item.index == index) {
								item.value = value
							}
							return true
						})
				}
			}
		})
	}

	private loadForm(section, data): JQueryPromise<void> {
		const deferred: JQueryDeferred<void> = $.Deferred<void>()
		section.items = []
		section.formData = {}
		let locationSelectedButtonAdded: boolean = false
		let locationButtonAdded: boolean = false
		let actorButtonAdded: boolean = false
		let taskGroupButtonAdded: boolean = false
		let simcardTariffButtonAdded: boolean = false
		const items: any[] = section.items
		const promises: JQueryPromise<any>[] = []

		for (let i = 0; i < section.columns.length; ++i) {
			let fieldIsAdded: boolean = false
			const column = section.columns[i]
			let visible: boolean = true

			if (column.id == CommonHelper.locationLatitude || column.id == CommonHelper.locationLongitude) {
				visible = false

				if (!locationSelectedButtonAdded) {
					items.push({
						visible: true,
						label: {
							text: i18n('Common', 'Location'),
						},
						colSpan: 2,
						template: '<location-select field-id="' + column.idName + '" coords="::getCoords()" callback="::onLocationSelected"></location-select>',
					})
					locationSelectedButtonAdded = true
					fieldIsAdded = true
				}
			} else {
				let referenceButtonNeedToPaint: boolean = false

				if (column.referenceTypeId == CommonHelper.IdLocation && !locationButtonAdded) {
					referenceButtonNeedToPaint = true
					locationButtonAdded = true
				}

				if (column.referenceTypeId == CommonHelper.IdActor && !actorButtonAdded) {
					referenceButtonNeedToPaint = true
					actorButtonAdded = true
				}

				if (column.referenceTypeId == CommonHelper.IdTaskGroup && !taskGroupButtonAdded) {
					referenceButtonNeedToPaint = true
					taskGroupButtonAdded = true
				}

				if (column.referenceTypeId == CommonHelper.IdTariff && !simcardTariffButtonAdded) {
					referenceButtonNeedToPaint = true
					simcardTariffButtonAdded = true
				}

				if (referenceButtonNeedToPaint) {
					visible = false
					let actionValue: string = 'empty'

					if (data) {
						if (data[column.id]) {
							actionValue = data[column.id].value
						}
					}

					items.push({
						visible: true,
						label: {
							text: column.caption,
						},
						colSpan: 1,
						template:
							'<select-popover field-id="' +
							column.idName +
							'" selected-id="' +
							actionValue +
							'" datatype-id="' +
							column.id +
							'"  options="{ referenceTypeId: ' +
							column.referenceTypeId +
							'}" callback="::onPopoverValueIdSelected"></select-popover>',
					})

					fieldIsAdded = true
				}
			}

			if (column.id != CommonHelper.userColumnPassword) {
				items.push({
					dataField: column.idName,
					visible: visible,
					label: {
						text: column.caption,
					},
					validationRules: [
						{
							type: 'pattern',
							pattern: '',
						},
					],
				})

				fieldIsAdded = true
			}

			if (fieldIsAdded) {
				if (section.required) {
					for (let j = 0; j < section.required.length; j++) {
						const req = section.required[j]

						if (req.id == column.id && column.type != CommonHelper.boolean) {
							items[items.length - 1].validationRules.push({
								type: 'required',
								message: i18n('Common', 'RequiredField'),
							})

							break
						}
					}
				}

				const promise: JQueryPromise<any> = this.addValidationRules(section, column, items[items.length - 1])

				if (promise != null) {
					promises.push(promise)
				}

				// set values
				section.formData[column.idName] = this.getFieldValue(data, column)
			}
		}

		const endUpdate = () => {
			setTimeout(() => {
				this.$scope.isLoading = false
				this.$scope.isFormVisible = true
				deferred.resolve()
			})
		}

		if (_.size(promises) > 0) {
			$.when(...promises)
				.catch((e) => {
					console.error(e)
				})
				.always(() => {
					endUpdate()
				})
		} else {
			endUpdate()
		}

		return deferred.promise()
	}

	private addValidationRules(section: CreateEditSection, column: ColumnModel, item: ExtendedFormItem = null): JQueryPromise<void> {
		const deferred: JQueryDeferred<void> = $.Deferred<void>()
		item.editorOptions = {}

		if (!item.validationRules) {
			item.validationRules = []
		}

		if (!column.isEditable && this.$scope.isEditMode) {
			item.editorOptions.readOnly = true
		}

		switch (column.type) {
			case CommonHelper.integer:
				const referenceType: number = column.referenceTypeId

				if (!referenceType) {
					if (item) {
						item.validationRules.push({
							type: 'pattern',
							pattern: '^-?[0-9]{0,}$',
							message: i18n('Common', 'IntegerField'),
						})
						if (column != null && column.format != null) {
							if (column.format.numberMaxValue) {
								item.validationRules.push({
									type: 'range',
									max: column.format.numberMaxValue,
									message: i18n('Common', 'NumberMaxValue') + ' ' + column.format.numberMaxValue,
								})
							}
							if (column.format.numberMinValue) {
								item.validationRules.push({
									type: 'range',
									min: column.format.numberMinValue,
									message: i18n('Common', 'NumberMinValue') + ' ' + column.format.numberMinValue,
								})
							}
						}
					}

					deferred.resolve()
					break
				} else if (referenceType && !item.template) {
					this.localDictionary
						.getReferenceTable(referenceType, column.id)
						.then((table) => {
							if (table && table.selectBoxData) {
								this.referenceTableCount += 1
								this.$scope['referenceTable' + this.referenceTableCount] = table.selectBoxData
								const selectText = i18n('Common', 'Select')
								const noDataText = i18n('Common', 'NoData')

								if (table.selectBoxData.length == 1 && (!this.$scope.panels[0].formData[column.idName] || this.$scope.panels[0].formData[column.idName].length == 0)) {
									this.$scope.panels[0].formData[column.idName] = table[0].id
								}

								item.template =
									'<div field-id="' +
									column.idName +
									'" id="table' +
									column.idName +
									'" dx-select-box="{dataSource: referenceTable' +
									this.referenceTableCount +
									', placeholder:' +
									"'" +
									selectText +
									"'" +
									', onSelectionChanged: panel.onFieldChanged, onValueChanged: panel.onFieldValueChanged, onInitialized: panel.initializedHandler, value: panel.formData[' +
									column.idName +
									"], valueExpr: 'id', searchEnabled: true, displayExpr: 'caption', noDataText: " +
									"'" +
									noDataText +
									"'" +
									' }"></div>'
							}
						})
						.finally(() => {
							deferred.resolve()
						})
				} else {
					deferred.resolve()
				}
				break
			case CommonHelper.string:
				section.formData[column.idName] = ''

				if (column.id == CommonHelper.userColumnPassword) {
					item.editorOptions.mode = 'password'
				}

				if (item) {
					if (column != null && column.format != null && column.format.textMinLength) {
						item.validationRules.push({
							type: 'stringLength',
							min: column.format.textMinLength,
							message: i18n('Common', 'MinNumberOfCharacters') + ' ' + column.format.textMinLength,
						})
					}

					if (column != null && column.format != null && column.format.textMaxLength) {
						item.validationRules.push({
							type: 'stringLength',
							max: column.format.textMaxLength,
							message: i18n('Common', 'MaxNumberOfCharacters') + ' ' + column.format.textMaxLength,
						})
					}
				}

				deferred.resolve()
				break
			case CommonHelper.datetime:
			case CommonHelper.date:
				const dateBoxOptions: DevExpress.ui.dxDateBoxOptions = this.dateBoxControlsService.getDateBoxOptions({
					format: ConfigHelper.getDateTimeFormat(ConfigHelper.DateFormat.DATE_FORMAT_DX, column.id),
				})

				section.formData[column.idName] = dateBoxOptions.value
				item.template =
					'<div field-id="' +
					column.idName +
					'" dx-date-box="{ displayFormat: ' +
					"'" +
					dateBoxOptions.displayFormat +
					"'" +
					', type:' +
					"'" +
					dateBoxOptions.type +
					"'" +
					", bindingOptions: { value: 'panel.formData[" +
					column.idName +
					']\' }, onValueChanged: panel.onDateFieldChanged }"></div>'

				deferred.resolve()
				break
			case CommonHelper.time:
				section.formData[column.idName] = new Date()
				item.template =
					'<div field-id="' +
					column.idName +
					'" dx-date-box="{ displayFormat: dateFormat, type:' +
					"'time'" +
					", bindingOptions: { value: 'panel.formData[" +
					column.idName +
					']\' }, onValueChanged: panel.onDateFieldChanged }"></div>'

				deferred.resolve()
				break
			case CommonHelper.real:
			case CommonHelper.decimal:
				if (item) {
					var comma = globalizeLocale().main('numbers/symbols-numberSystem-latn/decimal')
					var pattern = '^-?[0-9]{0,}((\\' + comma + '{1})[0-9]{0,})?$'

					item.editorType = 'dxTextBox'

					item.validationRules.push({
						type: 'pattern',
						pattern: pattern,
						message: i18n('Common', 'NumericField'),
					})
					if (column != null && column.format != null) {
						if (column.format.numberMaxValue) {
							item.validationRules.push({
								type: 'range',
								max: column.format.numberMaxValue,
								message: i18n('Common', 'NumberMaxValue') + ' ' + column.format.numberMaxValue,
							})
						}
						if (column.format.numberMinValue) {
							item.validationRules.push({
								type: 'range',
								min: column.format.numberMinValue,
								message: i18n('Common', 'NumberMinValue') + ' ' + column.format.numberMinValue,
							})
						}
						if (column.format.numberMinPrecision && column.format.numberMaxPrecision) {
							item.validationRules.push({
								type: 'pattern',
								pattern: '^\\d+\\.\\d{' + column.format.numberMinPrecision + ',' + column.format.numberMaxPrecision + '}$',
								message: i18n('Common', 'NumberPrecisionRange') + ' ' + column.format.numberMinPrecision + '-' + column.format.numberMaxPrecision,
							})
						} else if (column.format.numberMaxPrecision) {
							item.validationRules.push({
								type: 'pattern',
								pattern: '^\\d+(\\.\\d{1,' + column.format.numberMaxPrecision + '})?$',
								message: i18n('Common', 'NumberMaxPrecision') + ' ' + column.format.numberMaxPrecision,
							})
						} else if (column.format.numberMinPrecision) {
							item.validationRules.push({
								type: 'pattern',
								pattern: '^\\d+\\.\\d{' + column.format.numberMinPrecision + ',}$',
								message: i18n('Common', 'NumberMinPrecision') + ' ' + column.format.numberMinPrecision,
							})
						}
					}
				}

				deferred.resolve()
				break
			case CommonHelper.boolean:
				section.formData[column.idName] = false
				if (item) {
					item.validationRules[0] = {
						type: 'pattern',
						pattern: '',
					}
				}

				deferred.resolve()
				break
			default:
				deferred.resolve()
				break
		}

		return deferred.promise()
	}

	private getFieldValue(data, column) {
		var field = data[column.idName]
		if (field) {
			if (field.typeId == CommonHelper.datetime || field.typeId == CommonHelper.date || field.typeId == CommonHelper.time) {
				if (field.value != null) {
					var date = new Date(field.value)
					if (isNaN(date.getTime())) {
						return null
					} else {
						return date
					}
				} else {
					return new Date()
				}
			} else if (field.typeId == CommonHelper.boolean) {
				return !!field.value
			} else if (field.typeId === Enums.DataTypeClass.Real || field.typeId === Enums.DataTypeClass.Decimal) {
				return ConvertHelper.numberToLocalizedString(field.value)
			} else {
				if (column.id == CommonHelper.priorityColumnId) {
					if (field.value == null) {
						return 1
					}
				}
				return field.value
			}
		} else {
			if (column.type == CommonHelper.datetime || column.type == CommonHelper.date || column.type == CommonHelper.time) {
				return new Date()
			} else if (column.type == CommonHelper.boolean) {
				return false
			}

			if (column.id == CommonHelper.priorityColumnId) {
				return 1
			}
			return ''
		}
	}

	onPopoverValueIdSelected(valueId: number, datatypeId) {
		this.$scope.panels.forEach((panel) => {
			if (panel.formData[datatypeId] !== undefined) {
				panel.formData[datatypeId] = valueId
			}
		})
	}

	getCoords() {
		var latitude
		var longitude
		this.$scope.panels.forEach((panel) => {
			if (!panel.formData) return
			var lat = panel.formData[CommonHelper.locationLatitude]
			var lng = panel.formData[CommonHelper.locationLongitude]
			if (lat && lng) {
				latitude = lat
				longitude = lng
			}
		})
		if (latitude && longitude) {
			let coord = new OpCoord()
			coord.latitude = latitude
			coord.longitude = longitude
			return coord
		}
		return null
	}

	onLocationSelected(lat: number, lng: number) {
		this.$scope.panels.forEach((panel) => {
			if (panel.formData[CommonHelper.locationLatitude] != undefined) {
				panel.formData[CommonHelper.locationLatitude] = lat
			}
			if (panel.formData[CommonHelper.locationLongitude] != undefined) {
				panel.formData[CommonHelper.locationLongitude] = lng
			}
		})
	}

	private getActionTargetObjects(actionType: CorrespondingActionTypeModel): JQueryPromise<IOpObject[]> {
		return this.userSession
			.getDataProvider()
			.View.getActiveView(actionType.type)
			.then((view: OpView) => {
				const pkColumn: OpViewColumn = view.getPrimaryKeyColumn()

				const columnModel: ColumnModel = new ColumnModel()
				columnModel.sortDesc = null
				columnModel.id = pkColumn.idDataType
				columnModel.where = [`[${pkColumn.name}] in (${actionType.referenceValues.join(',')})`]
				columnModel.name = pkColumn.name
				columnModel.caption = pkColumn.caption

				const pkColumnInfo: ColumnInfo = new ColumnInfo(columnModel)

				if (this.isModuleActionType(actionType)) {
					return ReferenceTypeComponent.getFilterItemsByReferenceType(this.userSession.getDataProvider(), actionType.type, [pkColumnInfo], 1, 2147483647, columnModel.where[0]).then((result: any) => {
						if (result != null && result.objects != null && result.objects.length > 0) {
							return result.objects
						}

						return []
					})
				} else {
					return []
				}
			})
	}

	private runAction(action: CorrespondingActionTypeModel): JQueryPromise<void> {
		return this.getActionTargetObjects(action)
			.then((objects: IOpObject[]) => {
				const dataValues: DataValue[] = this.actionService.getDataValues(action)

				return this.userSession
					.getDataProvider()
					.Action.sendAction(action.id, action.referenceValues, action.type, dataValues)
					.then((result: OpActionResult[]) => {
						if (_.size(result) > 0) {
							this.previousSentActionsFail = false
							this.openActionStatusPopup(action, objects, result)
								.then(() => {
									if (this.alzActionComponent != null) {
										setTimeout(() => {
											this.alzActionComponent.hidePopup()
										}, 100)
									}
								})
								.fail(() => {
									this.previousSentActionsFail = true
									this.$scope.popupVisible = false
									ToastHelper.showError(LocalizationHelper.getLocalizedText('ProblemWithStatusDisplay', { collection: 'Popup' }))

									if (this.alzActionComponent != null) {
										this.alzActionComponent.hidePopup()
									}
								})
						} else {
							this.previousSentActionsFail = true
							this.$scope.popupVisible = false
							ToastHelper.showError(LocalizationHelper.getLocalizedText('ProblemWithStatusDisplay', { collection: 'Popup' }))

							if (this.alzActionComponent != null) {
								this.alzActionComponent.hidePopup()
							}
						}
					})
					.fail(() => {
						this.$scope.popupVisible = false
						this.previousSentActionsFail = true
						ToastHelper.showError(LocalizationHelper.getLocalizedText('ActionRunProblem', { collection: 'Popup' }))

						if (this.alzActionComponent != null) {
							this.alzActionComponent.hidePopup()
						}
					})
			})
			.fail(() => {
				this.$scope.popupVisible = false
				this.previousSentActionsFail = true
				CommonHelper.openInfoPopup(i18n('Popup', 'ActionRunProblem'), 'error', 5000)

				if (this.alzActionComponent != null) {
					this.alzActionComponent.hidePopup()
				}
			})
	}

	private openActionStatusPopup(actionType: CorrespondingActionTypeModel, objects: any[], actionResult: any[]): JQueryPromise<void> {
		const deferred: JQueryDeferred<void> = $.Deferred<void>()

		let rowNames: string[]
		let moduleDataType: number

		if (actionResult != null && actionResult.length > 0) {
			if (objects != null && this.isModuleActionType(actionType)) {
				this.userSession
					.getDataProvider()
					.View.getActiveView(actionType.type)
					.then((view: OpView) => {
						const pkColumn: OpViewColumn = view.getPrimaryKeyColumn()
						rowNames = objects.map((item: IOpObject) => item.toString())
						moduleDataType = pkColumn.idDataType

						deferred.resolve()
					})
			} else {
				rowNames = this.selectedRowsNames
				moduleDataType = this.moduleDataType

				deferred.resolve()
			}
		} else {
			deferred.resolve()
		}

		return deferred.promise().then(() => {
			if (actionResult != null && actionResult.length > 0) {
				const actionStatusOptions: ActionStatusOptions = {
					actionResult: actionResult,
					selectedRowsNames: rowNames,
					moduleDataType: moduleDataType,
				}

				this.$scope.$broadcast(EventsNames.SHOW_ACTION_STATUS_POPUP + this.$scope.popupId, actionStatusOptions)

				// Ten timeout jest tu po to, zeby event zostal obsluzony przez podrzedna kontrolke
				// Z uwagi, ze kontrolka action status jest zagniezdzona, musi sie pojawic
				// zanim zostanie zamknieta kontroloka action run
				setTimeout(() => {
					this.$scope.popupVisible = false
				}, 100)
			}
		})
	}

	private isModuleActionType(actionType: CorrespondingActionTypeModel): boolean {
		return actionType.type != this.userSession.getDataProvider().DataType.getDataTypeLocal(this.moduleDataType).idReferenceType
	}

	// Get corresponding action type from grid
	public static openActionPopup(
		$scope: ng.IScope,
		$timeout: ng.ITimeoutService,
		dataProvider: DataProvider,
		data: { id: number; name: string }[],
		referenceType: Enums.ReferenceType,
		popupId: number | string,
		filterActionTypes?: (actionTypes: OpActionType[]) => OpActionType[]
	): JQueryPromise<void> {
		$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)

		const defer = jQuery.Deferred<void>()
		const availableActions: ActionRun[] = []

		const referenceValues: number[] = data.map((selectedRow) => {
			return selectedRow[CommonHelper.idField]
		})
		const selectedRowsNames: string[] = data.map((selectedRow) => {
			return selectedRow[CommonHelper.nameField]
		})

		dataProvider.Action.getCorrespondingActionType(referenceValues, referenceType)
			.then((actionTypes: OpActionType[]) => {
				if (_.isFunction(filterActionTypes)) {
					actionTypes = filterActionTypes(actionTypes)
				}

				actionTypes.forEach((actionType: OpActionType) => {
					availableActions.push({
						id: actionType.idActionType,
						name: actionType.toString(),
						originalName: actionType.name,
						type: actionType.referenceType,
						referenceValues: actionType.referenceValue,
						isActionDataFixed: actionType.isActionDataFixed,
					})
				})

				let idDataType: number
				switch (referenceType) {
					case Enums.ReferenceType.IdLocation:
						idDataType = DataType.HELPER_ID_LOCATION
						break
					case Enums.ReferenceType.IdMeter:
						idDataType = DataType.HELPER_ID_METER
						break
					case Enums.ReferenceType.SerialNbr:
						idDataType = DataType.HELPER_SERIAL_NBR
						break
				}

				const options: ActionRunOptions = {
					actions: availableActions,
					idDataType: idDataType,
					selectedRowsNames: selectedRowsNames,
					actionTypes: TypeHelper.clone(actionTypes),
				}

				setTimeout(() => {
					$scope.$broadcast(EventsNames.OPEN_RUN_ACTION_POPUP + popupId, options)
					defer.resolve()
				}, 500)
			})
			.fail((error: any) => {
				let errorMsg: string = error

				if (SESSION.isType(error)) {
					errorMsg = (<SESSION>error).toString()
				}

				defer.reject(errorMsg)
			})
			.always(() => {
				$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
			})

		return defer.promise()
	}

	// #region Dedicated Valve State

	private initializeValveManagmentPopup(action: CorrespondingActionTypeModel): void {
		if (action.fields === undefined) {
			action.fields = []
		}
		if (this.valveManagmentComponent != null) {
			this.valveManagmentComponent.setReferencValues(action.referenceValues)
			this.valveManagmentComponent.setAction(action)
			this.valveManagmentComponent.showPopup()
		} else {
			this.$scope.valveManagePopupOptions = {
				onInitialized: (e: ValveManageInitializedArgs) => {
					this.valveManagmentComponent = e.component
					e.component.showPopup()
				},
				referenceValues: action.referenceValues,
				action: action,
				onActionRunClick: (correspondingAction: CorrespondingActionTypeModel) => {
					correspondingAction.isActionDataFixed = false
					this.runAction(correspondingAction)
				},
			}
		}
	}

	// #endregion

	// #region ALZ configuration

	private initializeAlzActionPopup(action: CorrespondingActionTypeModel): void {
		if (action.fields == null) {
			action.fields = []
		}

		if (this.alzActionComponent != null) {
			this.alzActionComponent.setAction(action)
			this.alzActionComponent.showPopup()
		} else {
			this.$scope.alzActionPopupOptions = {
				onInitialized: (e: AlzActionInitializedArgs) => {
					this.alzActionComponent = e.component
					e.component.showPopup()
				},
				onHiding: () => {
					this.$scope.popup.hide()
				},
				referenceValues: action.referenceValues,
				action: action,
				onActionRunClick: (correspondingAction: CorrespondingActionTypeModel) => {
					correspondingAction.isActionDataFixed = false
					this.runAction(correspondingAction)
				},
			}
		}
	}

	// #endregion

	// #region ASTgsm configuration

	private initializeAstGsmActionPopup(action: CorrespondingActionTypeModel): void {
		if (action.fields == null) {
			action.fields = []
		}

		if (this.astGsmActionComponent != null) {
			this.astGsmActionComponent.setAction(action)
			this.astGsmActionComponent.showPopup()
		} else {
			this.$scope.astGsmActionPopupOptions = {
				onInitialized: (e: AstGsmActionInitializedArgs) => {
					this.astGsmActionComponent = e.component
					e.component.showPopup()
				},
				onHiding: () => {
					this.$scope.popup.hide()
				},
				referenceValues: action.referenceValues,
				action: action,
				onActionRunClick: (command: string) => {
					action.isActionDataFixed = false
					this.runAstGsmAction(action.referenceValues, command, action)
				},
			}
		}
	}

	private runAstGsmAction(serialNbrs: number[], command: string, action: CorrespondingActionTypeModel): void {
		this.userSession
			.getDataProvider()
			.Action.sendAstGsmCommandAction(serialNbrs, command)
			.then((result: OpActionResult[]) => {
				if (_.size(result) > 0) {
					this.previousSentActionsFail = false
					this.openActionStatusPopup(action, [], result)
						.then(() => {
							if (this.astGsmActionComponent != null) {
								setTimeout(() => {
									this.astGsmActionComponent.hidePopup()
								}, 100)
							}
						})
						.fail(() => {
							this.previousSentActionsFail = true
							this.$scope.popupVisible = false
							ToastHelper.showError(LocalizationHelper.getLocalizedText('ProblemWithStatusDisplay', { collection: 'Popup' }))

							if (this.astGsmActionComponent != null) {
								this.astGsmActionComponent.hidePopup()
							}
						})
				} else {
					this.previousSentActionsFail = true
					this.$scope.popupVisible = false
					ToastHelper.showError(LocalizationHelper.getLocalizedText('ProblemWithStatusDisplay', { collection: 'Popup' }))

					if (this.astGsmActionComponent != null) {
						this.astGsmActionComponent.hidePopup()
					}
				}
			})
			.fail(() => {
				this.$scope.popupVisible = false
				this.previousSentActionsFail = true
				ToastHelper.showError(LocalizationHelper.getLocalizedText('ActionRunProblem', { collection: 'Popup' }))

				if (this.astGsmActionComponent != null) {
					this.astGsmActionComponent.hidePopup()
				}
			})
	}

	// #endregion

	// #region immediatelyArchDateAction configuration

	private initializeImmediatelyArchDateActionPopup(action: CorrespondingActionTypeModel): void {
		if (action.fields == null) {
			action.fields = []
		}

		if (this.immediatelyArchDateActionComponent != null) {
			this.immediatelyArchDateActionComponent.setAction(action)
			this.immediatelyArchDateActionComponent.showPopup()
		} else {
			this.$scope.immediatelyArchDateActionPopupOptions = {
				onInitialized: (e: ImmediatelyArchDateActionInitializedArgs) => {
					this.immediatelyArchDateActionComponent = e.component
					e.component.showPopup()
				},
				onHiding: () => {
					this.$scope.popup.hide()
				},
				referenceValues: action.referenceValues,
				action: action,
				onActionRunClick: (correspondingAction: CorrespondingActionTypeModel) => {
					correspondingAction.isActionDataFixed = false
					return this.runAction(correspondingAction)
				},
			}
		}
	}

	// #endregion
}
